import { RichTextEditor } from 'core-components/library/richTextEditor'

export interface IViewCriteriaProps {
  content: string
}

export const ViewCriteria = ({ content }: IViewCriteriaProps) => {
  return <RichTextEditor value={content} toolbarVisible={false} autoFocus={false} disabled={true} />
}
